// extracted by mini-css-extract-plugin
export default {"root":"classes_root__45H98","qrcode":"classes_qrcode__x2QBm"};